import {Injectable} from '@angular/core';
import {DialogData, ErrorModalComponent} from "../components/shared/modals/error-modal/error-modal.component";
import {MatDialog} from "@angular/material/dialog";
import { laDialogMessage, LaWarningComponent } from "../shared/warning-popups/la-warning/la-warning.component";

@Injectable({
  providedIn: 'root'
})
export class ErrorMessageService {

  constructor(public Dialog: MatDialog) { }

  showErrorModal(headerMessage:string, errorMessages: any, callback?: () => void) {
    const initialState: DialogData = {
      headerMessage: headerMessage,
      errorMessages: errorMessages
    };
    const dialogRef = this.Dialog.open(ErrorModalComponent, {
      data: initialState
    });

    if (callback) {
      dialogRef.afterClosed().subscribe(() => {
        callback();
      });
    }
  }
  showLAErrorModal(errorMessages: any){
    const initialState: laDialogMessage = {
      errorMessages: errorMessages,
      hasCancel: false
    };
    this.Dialog.open(LaWarningComponent, {
      data: initialState,
      panelClass: 'la-warning-message'
    });
  }
}
